import OwnerType from '../ownerType';
export default class Freehold extends OwnerType {
  constructor() {
    super();
    this.id = 'freehold';
    this.name = "Selveier";
    this.icon = "mdi-account-check";
  }
}